import React from 'react';
import { render } from 'react-dom';

import { AppFrequentlyBoughtTogether } from 'apps/frequentlyBoughtTogether';
import { setGenericEvent } from 'features/tealium/ga4/custom';

function initFrequentlyBoughtTogether (products: Array<LP.product.ProductItem>, shortSku: string, frequentlyBoughtSectionElement: HTMLElement) {

	setGenericEvent({
		event_name: 'pdp_fbt_load',
		pdp_item_id: shortSku,
		pdp_prime_cat: window.utag_data.product_category[0]
	});

	render(
		<AppFrequentlyBoughtTogether
			shortSku={shortSku}
			products={products}
		/>,
		frequentlyBoughtSectionElement.querySelector('#frequentlyBoughtTogetherContent')
	);

}

export default initFrequentlyBoughtTogether;
